// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__D0qIa","title":"FrontImage_title__29MYt"};